import React, { memo, useRef } from 'react'
import {
    AppBar,
    Toolbar,
    Avatar,
    Badge,
    IconButton,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
} from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import CloseIcon from '@mui/icons-material/Close'
import { useLocation, useNavigate } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import ReconnectingWebSocket from 'reconnecting-websocket'

import Utils from '../../utils'
import MainLogo from '../../../src/assets/image/png/Logotheme.png'
import ImageZoom from '../../common/image-zoom'
import bellring from '../../assets/image/svg/notification.svg'
import LocalStorage from '../../defined/localStorage'
import { getValueFromObjectByKeys, translate } from '../../helper'
import { UserAction } from '../../redux/action'
import withNavigate from '../../component/WithNavigate'
import { userDetailApiCall } from '../modules/UserProfile/Action'
import { ContainedButton } from '../common/inputs/Button'

const brand = JSON.parse(LocalStorage.getItem('branding'))

function Logo() {
    return (
        <svg style={{ width: "40px", height: "40px" }} focusable="false" aria-hidden="true" viewBox="0 0 49 49" data-testid="AddCircleIcon" class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv">
            <style type="text/css">
                {
                    "\n.st0 {\nopacity: 0.3;\nfill-rule: evenodd;\nclip-rule: evenodd;\nfill: #FFFFFF;\n}\n.st1 {\nfill-rule: evenodd;\nclip-rule: evenodd;\nfill: rgba(255, 255, 2550.3);\n}\n"
                }
            </style>
            <circle id="Circle" class="st0" cx="24.5" cy="24.5" r="24.5"></circle>
            <path id="Plus" class="st1" d="M36.6,25.5H25.2v11.1h-1.7V25.5H12.4v-1.7h11.1V12.4h1.7v11.4h11.4V25.5z"></path>
        </svg>
    )
}

function MobileHeader({
    title,
    noAuth,
    showNotification,
    showProfileIcon,
    showNavigation,
    backTo,
    notificationsData,
    getNotificationsCount,
    showCentreProfile,
    withoutname,
    authscreen,
    showAddOrder,
    updateUserNotificationCount,
}) {
    const { data: authData } = useSelector(state => state.auth)
    const { data: userDetail } = useSelector(state => state.user_detail)
    const whiteLabel = useSelector(state => state.User?.branding)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const wsNotifications = useRef(null)

    const [requireInfoOpen, setRequireInfoOpen] = React.useState(false)
    const [profileMessage, setProfileMessage] = React.useState('')

    const dt = location.pathname.includes('/dealer')
    const endpointType = dt ? 'dealerTechnicianEndpoints' : 'userMobileEndpoints'

    const isProfileComplete = (profile = {}) => {
        const requiredProfileFields = ['full_name', 'country', 'state', 'address', 'city', 'zip_code', 'phone_number']
        return requiredProfileFields.every((field) => {
            if (field === 'phone_number') {
                const phone = profile?.phone_number
                return !!(phone && phone?.national_number && phone?.country_code)
            }
            return !!profile?.[field]
        })
    }

    const getProfileMissingMessage = (profile = {}) => {

        const hasName = !!profile?.full_name;

        const hasPhone = !!(
            profile?.phone_number?.national_number &&
            profile?.phone_number?.country_code
        );

        const hasAddress =
            !!profile?.country &&
            !!profile?.state &&
            !!profile?.address &&
            !!profile?.city &&
            !!profile?.zip_code;

        let missingParts = [];

        if (!hasName) {
            missingParts.push("name");
        }

        if (!hasPhone) {
            missingParts.push("phone number");
        }

        if (!hasAddress) {
            missingParts.push("address");
        }

        const formattedParts = missingParts.join(", ").replace(/,([^,]*)$/, " and$1");

        return `To place your first order, please add your ${formattedParts} to your profile.`;
    };


    const handleAddOrderClick = () => {

        const profile = userDetail || {};
        const complete = isProfileComplete(profile);

        if (!complete) {
            const msg = getProfileMissingMessage(profile);
            setProfileMessage(msg);
            setRequireInfoOpen(true);
        } else {
            navigate(Utils.EndPoint[endpointType].addNewOrder);
        }

    };


    React.useEffect(() => {
        if (!authData?.token) return

        // Close existing WebSocket before creating a new one
        if (wsNotifications.current) {
            wsNotifications.current.close()
        }

        wsNotifications.current = new ReconnectingWebSocket(
            `wss://${Utils.constants.API_URL.replace('https://', '')}ws/home/notifications/?token=${authData.token}`
        )


        wsNotifications.current.addEventListener('message', (e) => {
            if (e.type === 'open') {
                // getNotificationsCount()
                // if(window.location.pathname.includes('user-notification')){
                //     getNotifications()
                // }
            }
        })

        wsNotifications.current.onmessage = (event) => {
            const data = JSON.parse(event.data)
            updateUserNotificationCount(data)
        }
        getNotificationsCount()
        userDetailApiCall(dispatch, authData)

        // Cleanup: Close WebSocket on unmount or when token changes
        return () => {
            if (wsNotifications.current) {
                wsNotifications.current.close()
            }
        }
    }, [authData?.token])

    return (
        <>
            <AppBar
                position="static"
                sx={{
                    backgroundColor: authscreen
                        ? '#fff'
                        : whiteLabel?.mobile_top_banner_color ||
                        brand?.mobile_top_banner_color ||
                        '#ffd22f',
                    boxShadow: 'none',
                    justifyContent: 'flex-end',
                    '& .MuiIconButton-root': {
                        color: '#fff',
                    },

                    '& .MuiBadge-badge': {
                        right: '1px',
                        backgroundColor: 'red',
                        fontWeight: 700,
                    },
                }}
            >
                <Toolbar sx={{
                    minHeight: 'auto',
                    padding: '0.5rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: noAuth ? 'center' : 'space-between',
                }}>
                    {noAuth && (
                        <Box
                            className="imageContainer"
                            sx={{
                                backgroundImage: 'url(/Images/signupTop.png)',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                display: 'flex',
                                justifyContent: 'center', alignItems: 'center',
                                py: 2,
                                textAlign: 'center',
                            }}
                        >
                            <Avatar
                                src={whiteLabel?.mobile_logo || brand?.mobile_logo || MainLogo}
                                sx={{ width: 60, height: 60, borderRadius: '5px' }}
                            />
                        </Box>
                    )}

                    {(showProfileIcon || showNavigation) && <Box sx={{ width: 40 }}>
                        {showProfileIcon && (
                            <ImageZoom imageSrc={userDetail?.profile_image} fullScreen>
                                <Avatar
                                    src={userDetail?.profile_image}
                                    sx={{ width: 40, height: 40, border: '1px solid #fff', borderRadius: '50px' }}
                                />
                            </ImageZoom>
                        )}

                        {showNavigation && (
                            <IconButton
                                onClick={() => (backTo ? backTo() : navigate(-1))}
                            >
                                <ArrowBackIosIcon sx={{ color: '#fff' }} />
                            </IconButton>
                        )}
                    </Box>}

                    {(title || showCentreProfile) && <Box sx={{ flex: 1, textAlign: 'center' }}>
                        {title && (
                            <Typography
                                fontSize="18px"
                                fontWeight={600}
                                sx={{ textTransform: 'uppercase', color: '#fff' }}
                            >
                                {translate(title)}
                            </Typography>
                        )}

                        {showCentreProfile && (
                            <ImageZoom
                                imageSrc={userDetail?.profile_image}
                                altSrc={userDetail?.profile_image}
                                fullScreen
                            >
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginBottom: !withoutname ? '0px' : '5px'
                                }}>
                                    <Avatar
                                        src={userDetail?.profile_image}
                                        alt="Profile Image"
                                        sx={{
                                            width: withoutname ? 55 : 75,
                                            height: withoutname ? 55 : 75,
                                            mx: 'auto',
                                            borderRadius: '50px',
                                            marginBottom: !withoutname ? '12px' : '0px',
                                            border: '1px solid #fff',
                                        }}
                                    />
                                    {!withoutname && <Typography marginTop={'2px'} marginBottom={'10px'} color={'white'} lineHeight={'15.9px'}
                                        fontWeight={'600'}
                                        variant="span">{userDetail?.full_name}</Typography>}
                                </div></ImageZoom>
                        )}
                    </Box>}

                    {showNotification && <Box sx={{ width: 40, textAlign: 'right' }}>
                        <IconButton
                            onClick={() =>
                                navigate(
                                    Utils.EndPoint[endpointType].userNotification
                                )
                            }
                        >
                            <Badge
                                badgeContent={notificationsData?.unread_count}
                                color="error"
                            >
                                <img src={bellring} style={{ width: '30px', height: '30px' }} />
                            </Badge>
                        </IconButton>
                    </Box>}

                </Toolbar>

                {showAddOrder && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 2,
                            pb: 2,
                            cursor: 'pointer',
                        }}
                        onClick={handleAddOrderClick}
                    >
                        <Logo />
                        <Box ml={1}>
                            <Typography color="#fff" fontSize={16}>
                                Add Order
                            </Typography>
                            <Typography color="#fff" fontSize={14} fontWeight={300}>
                                Start a new order...
                            </Typography>
                        </Box>
                    </Box>
                )}

            </AppBar>

            <Dialog open={requireInfoOpen} onClose={() => setRequireInfoOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 1
                }}>
                    {translate("completeYourProfile")}
                    <IconButton
                        size="small"
                        onClick={() => setRequireInfoOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <Typography variant="body" color="text.secondary">
                        {profileMessage}
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setRequireInfoOpen(false)}
                    >
                        {translate("maybeLater")}
                    </Button>

                    <ContainedButton
                        variant="contained"
                        onClick={() => {
                            setRequireInfoOpen(false);
                            navigate(
                                Utils.EndPoint[endpointType].updateProfile,
                                { state: { fromHeaderRequireInfo: true } }
                            );
                        }}
                    >
                        {translate("updateProfile")}
                    </ContainedButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        notificationsData: getValueFromObjectByKeys(state, ['User', 'notifications'])
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getNotifications: () => dispatch(UserAction.getNotifications()),
        getNotificationsCount: () => dispatch(UserAction.getUnreadNotifCount()),
        updateUserNotificationCount: (count) => dispatch(UserAction.updateUserNotificationCount(count))
    }
}

export default memo(connect(mapStateToProps, mapDispatchToProps)(withNavigate(MobileHeader)))
